import '.c4{position:relative;}.ssr-plugin'
import '.i5{width:64px;}.ssr-plugin'
import '.i6{height:64px;}.ssr-plugin'
import '.cd{flex-shrink:0;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.i7{bottom:-4px;}.ssr-plugin'
import '.d7{right:-4px;}.ssr-plugin'
import '.d0{border-radius:50%;}.ssr-plugin'
import '.i8{border:2px solid var(--shades-white);}.ssr-plugin'
import '.a6{overflow:hidden;}.ssr-plugin'
import '.i9{width:32px;}.ssr-plugin'
import '.ia{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c4 i5 i6 cd"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="a2 i7 d7 d0 i8 a6 i9 ia"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
